<template>
  <div id="english" style="display: block">
    <h2>
      {{
        this.$i18n.t("Thank you for your interest", {
          school_name: this.registration.school_name,
        })
      }}
    </h2>
    <h2>{{ this.$i18n.t("Registration Details") }}</h2>
    <p>
      <strong
        >{{ this.$i18n.t("Electoral District" + this.election["province"]) }}:
        {{ this.registration.district_name }}</strong
      >
    </p>
    <p>
      {{ this.$i18n.t("Team Leader") }}: {{ this.registration.first_name }}
      {{ this.registration.last_name }}<br />
      {{ this.$i18n.t("Registration date") }}:
      {{ this.registration.DateRegistered }}
    </p>

    <hr size="1" />
    <!-- <p
      v-html="
        this.$i18n.t(
          'If you would like to include your class in the riding above'
        )
      "
    ></p> -->
    <p>
      {{
        this.$i18n.t(
          "If you would like to ensure your class can also participate, please do the following:"
        )
      }}<br /><br />
      <span v-html="$t('step_1_error')"></span><br />
      <span v-html="$t('step_2_error')"></span><br />
      <!-- <span
        v-html="
          $t('step_3_error', {
            election_name: election_name,
          })
        "
      ></span
      > -->
      <br />
    </p>
    <p>
      <span
        v-html="
          this.dupeString
        "
      ></span>
      <a style='' @click="loadRegistration()" >{{ this.$i18n.t("click here") }}</a
      >.
    </p>
  </div>
</template>

<script>
export default {
  name: "Error",
  data: function () {
    return {
      registration: {
        school_name: "",
      },
      election: null,
      election_name: "",
      dupeString: ""
    };
  },
  props: {
    election_id: String,
    school: String,
  },
  mounted: function () {
    // this.getRegistration(this.election_id, this.school)
  },
  beforeMount() {
    this.getRegistration(this.election_id, this.school);
  },
  methods: {
    goBack() {
      history.go(-1);
    }, 
    loadRegistration() {
      this.$router.push({
        name: "registration",
        params: {
          dupe: 1,
        },
      });
    },
    getRegistration(election_id, school) {
      let url = this.$API + "/get_registration";

      var payload = {
        election_id: election_id,
        school: school,
        lang: this.$LANG
      };

      fetch(url, {
        method: "POST",
        body: JSON.stringify(payload),
        //headers: new Headers({
        //  'x-api-key': this.this.$i18n.tTOKEN
        //})
      })
        .then((stream) => stream.json())
        .then((response) => {
          console.log(response);
          if (response.error) {
            // console.log(response.error);
          } else {
            // console.log(response);
            this.registration = response.registration;
            this.election = response.election;

            this.election_name = this.election["election_name"];
            if (this.$LANG === "fr") {
              this.election_name = this.election["fname"];
            }

            const st = this.$i18n.t(
                'To register this school for a different electoral district than  listed above' +
                this.election['province']
              ).replace('{LOAD_REG}', "<a @click='loadRegistration()'>create a new registration</a>");
            console.log(st);
            this.dupeString = st;

          }
        })
        .catch((error) => {
          this.isLoading = false;
          // console.log(error);
        });
    },
  },
};
</script>